module.exports = __webpack_public_path__ + "img/3.f811dc55.jpg";